<mat-dialog-content>
    <h2 mat-dialog-title *ngIf="data.title">{{data.title}}</h2>
    <p *ngIf="data.description">{{data.description}}</p>
</mat-dialog-content>

<mat-dialog-actions fxLayout="row" fxLayout.xs="column" fxLayoutAlign="end">
    <button mat-raised-button class="save" color="primary" (click)="okClicked()">{{'OK' | translate}}</button>
</mat-dialog-actions>